import React from "react";
import { Avatar } from "antd";
import dayjs from "dayjs";

const Header = ({ post, onRoute, isMobile }) => {
  return (
    <div className="header">
      <Avatar src={post?.blog?.author?.profileImage}>
        {post?.blog?.author?.firstName[0]}
        {post?.blog?.author?.lastName[0]}
      </Avatar>
      <p>
        by{" "}
        <span onClick={(e) => onRoute(e, "about")}>
          Dr.&nbsp;{post?.blog?.author?.firstName}&nbsp;
          {post?.blog?.author?.lastName}
        </span>{" "}
        in <span onClick={(e) => onRoute(e, "posts")}>{post?.blog?.title}</span>
      </p>
      {!isMobile && (
        <p>&#x2022;&nbsp;{dayjs(post?.updatedAt).format("DD MMM YYYY")}</p>
      )}
    </div>
  );
};

export default Header;
